module.exports = __webpack_public_path__ + "static/media/elegirSucursal__metro.c2b9c337.svg";